module.exports = __webpack_public_path__ + "img/logo_clikautomobility.094a6318.png";